module.exports = __webpack_public_path__ + "CR.png?5fb2f06a499e2ecdb77d5ca608643d20";